import { useEffect, useRef, useState } from "react";
import { Stack, TextInput, Text, Card, Divider, Group, NumberInput, Box, Textarea, InputLabel } from "@mantine/core";
import { searchBondByBondNoAndEmail } from "../../Protocol";
import { IconAlertCircle, IconCircleCheck, IconMail } from "@tabler/icons-react";

interface PrefillData {
  trusteeName: string;
  fileNumber: string;
  debtorName: string;
  creditorName: string;
  bondAmount: number;
  newTotalBondAmount: number;
  bondId: string;
  email: string;
  increaseAmount: number;
  loading: boolean;
}

 

export const BondSearch = ({ bondNumber, onRiderChange }: { bondNumber: string, onRiderChange: any }) => {
  const [prefillData, setPrefillData] = useState<PrefillData | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [email, setEmail] = useState("");
  const [increaseValue, setIncreaseValue] = useState<number>(0);
  const [emailValid, setEmailValid] = useState(false);
  // const increaseAmount = useRef<HTMLInputElement>(null); 
  useEffect(() => { 
    if(bondNumber.trim() === "" || bondNumber.length <10){
      onRiderChange({isLoading: false  })
      setPrefillData(null); 
      return;
    }

    if (!email || email.trim() === "") {
    //   setEmailError(false);
      setEmailValid(false);
      onRiderChange({isLoading: false  })
      setPrefillData(null); 
    //   searching_email = false;
      return;
    }
  
    const debounceTimeout = setTimeout(() => {
        fetchPrefillData();
    }, 500);
  
    return () => {
      clearTimeout(debounceTimeout); 
    };
  }, [email,bondNumber]);


  useEffect(() => { 
    if (prefillData) {
      setIncreaseValue(prefillData.newTotalBondAmount - prefillData.bondAmount);
        // increaseAmount.current!.value = (prefillData.newTotalBondAmount - prefillData.bondAmount).toString();
    }
  }, [prefillData]);

  const fetchPrefillData = async () => {
    
    setPrefillData(null);
    setError(null);
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setEmailValid(false); 
        setError("Please enter a valid email address.");
        onRiderChange({isLoading: false  }) 
        setPrefillData(null); 
        return;
    }
 
    try {
      onRiderChange({isLoading: true })
      setError(null); 
      const response = await searchBondByBondNoAndEmail(bondNumber.trim(), email.trim());
      if (response.success) {
        const data = response.data
        if(data && data.isRider){
          onRiderChange({isLoading: false  })
          setError("Bond is already a Rider. Contact Insurance Masters, Inc. 410.971.5869.");
          return;
        }
         
        setPrefillData({...data, email: email,newTotalBondAmount : data.bondAmount});
        onRiderChange({...data, email: email,newTotalBondAmount : data.bondAmount, isLoading: false});
        setEmailValid(true);
        console.log(data);
      } else {
        setEmailValid(false);
        setPrefillData(null); 
        setError(response.message);
        onRiderChange({isLoading: false  }) 
        return;
      }
    }catch (err) {
      setPrefillData(null); 
      setEmailValid(false);
      setError("Error fetching prefill data");
      onRiderChange({isLoading: false  }) 
      console.error(err);
      return;
    }  
  };
  
  return (
    <Stack>
        
      <Card>
        <Text>Please enter your email</Text>
        <Divider />

        <Textarea
          styles={{input: {fontSize: '22px', paddingTop:'initial', backgroundColor: '#f1f3f5 '}}}
          minRows={1}
          autosize
          required
          leftSection={<IconMail />}
          value={email}
          onChange={(e) => setEmail(e.currentTarget.value)} 
          tabIndex={2}
        //   error={error ? error : undefined}
        />

        {emailValid && (
          <Group>
            <IconCircleCheck color="green" />
            <Text fz="xs">We found your information in our system.</Text>
          </Group>
        )}
        {!emailValid && error && (
            <Group>
                <IconAlertCircle color="red" />
                <Text fz="xs">{error}</Text>
            </Group>
        )}
        <Divider />
      </Card> 
      
      {prefillData && (
        <>
          <Text  styles={{root: {backgroundColor: '#fbcb3e', padding: '0.5rem 1rem'}}}>
          If any of these information
              is not accurate, do not submit the rider request with this program, send an email to
              MTBerman@msn.com
          </Text> 
        <Card>
             <Group>
                <NumberInput  hideControls label="New Total Bond Amount" min={prefillData.bondAmount}  styles={{ input: { borderColor: '#e31e1e' }  }} value={prefillData.newTotalBondAmount} required 
                    onChange={(e) => { 
                        setPrefillData({ ...prefillData, newTotalBondAmount: Number(e) })
                        onRiderChange({ ...prefillData, newTotalBondAmount: Number(e) })
                        } 
                    } 
                    tabIndex={3}
                    thousandSeparator=","
                    />  
                <NumberInput thousandSeparator="," tabIndex={-1} label="Increase Amount" min={0} value={increaseValue} readOnly styles={{input: { backgroundColor: "white", color: "black", cursor: "not-allowed" }}}/>
                <NumberInput thousandSeparator="," tabIndex={-1} label="Original Bond Amount" value={prefillData.bondAmount} readOnly styles={{input: { backgroundColor: "white", color: "black", cursor: "not-allowed" }}} />
            </Group>
            <Textarea
            styles={{ input: { backgroundColor: '#f1f3f5', fontSize: '22px' }  }} 
                minRows={1}
                autosize
                label="Trustee Name (Check the accuracy of the trustees for this bond and change if necessary)"
                value={prefillData.trusteeName}
                onChange={(e) => { 
                    setPrefillData({ ...prefillData, trusteeName: e.currentTarget.value })
                    onRiderChange({ ...prefillData, trusteeName: e.currentTarget.value })
                    }
                } 
                tabIndex={4}
            />
            <InputLabel size="sm" fw={500} style={{marginTop: '10px',fontSize:'22px'}}>
              File # Read Only
            </InputLabel>
            <div style={{border: '1px solid #ced4da', borderRadius: 4, padding: '0.75rem', backgroundColor: 'white', color: 'black', fontSize: '22px', cursor: 'not-allowed'}}>
            {prefillData.fileNumber}
            </div>
            <InputLabel size="sm" fw={500} style={{marginTop: '10px',fontSize:'22px'}}>
              Debtor Read Only
            </InputLabel>
            <div style={{border: '1px solid #ced4da', borderRadius: 4, padding: '0.75rem', backgroundColor: 'white', color: 'black', fontSize: '22px', cursor: 'not-allowed'}}>
            {prefillData.debtorName}
            </div>
            <InputLabel size="sm" fw={500} style={{marginTop: '10px',fontSize:'22px'}}>
              Creditor Read Only
            </InputLabel>
            <div style={{border: '1px solid #ced4da', borderRadius: 4, padding: '0.75rem', backgroundColor: 'white', color: 'black', fontSize: '22px', cursor: 'not-allowed'}}>
            {prefillData.creditorName}
            </div>
        </Card>
        </>
      )}
    </Stack>
  );
};

